import React from 'react';
import "../../Styles/ViewFeeStructure2.css";
import { Printer, } from 'lucide-react';

const FeeStructure = () => {
  return (
    <div className="FS-page-wrapper">
      <div className="FS-main-container">
        <div className="FS-header-special-row">
          <h1 className="FS-title-text">View Fee Structure</h1>
          <div className="FS-header-actions-group">
            <span style={{fontSize: '13px', color: '#666', marginRight: '10px'}}>
              Display Header <input type="checkbox" defaultChecked />
            </span>
           <button className="FS-btn-common FS-btn-print-color">
    Print <Printer size={16}/>
  </button>
  
  <button className="FS-btn-common FS-btn-edit-color">
    Edit
  </button>
  
  <button className="FS-btn-common FS-btn-delete-color">
    Delete
  </button>
          </div>
        </div>

        <div className="FS-section-row">
          <div className="FS-box-card">
            <div className="FS-details-row">
              <div className="FS-details-label">Grade Name</div>
              <div className="FS-details-value">10(A)</div>
            </div>
            <div className="FS-details-row">
              <div className="FS-details-label">Academic Year Name</div>
              <div className="FS-details-value">2025-2026</div>
            </div>
          </div>
        </div>

        <div className="FS-section-row">
          <div className="FS-box-card">
            <div className="FS-term-title-bar">Terms/Semester : Sem-II</div>
            <div className="FS-main-fee-row">
              <span>+ &nbsp; Tution</span>
              <span className="FS-bold-amount-value">$ 10000</span>
            </div>
            <div className="FS-sub-item-container">
              <div className="FS-sub-item-row"><span>1. Sibling</span><span>$ 2500%</span></div>
              <div className="FS-sub-item-row"><span>2. Staff</span><span>$ 250%</span></div>
              <div className="FS-sub-item-row"><span>3. Promotional</span><span>$ 2500%</span></div>
              <div className="FS-sub-item-row"><span>4. Full Payment</span><span>$ 250%</span></div>
              <div className="FS-sub-item-row"><span>5. Taxes</span><span>$ 250%</span></div>
              <div className="FS-sub-item-row"><span>6. Non-Residence</span><span>$ 250%</span></div>
            </div>
          </div>
        </div>

        <div className="FS-section-row">
          <div className="FS-box-card">
            <div className="FS-main-fee-row">
              <span>+ &nbsp; Penality</span>
              <span className="FS-bold-amount-value">$ 100</span>
            </div>
          </div>
        </div>

        <div className="FS-section-row">
          <div className="FS-box-card">
            <div className="FS-total-summary-row">
              <span>Total Amount</span>
              <span className="FS-bold-amount-value">$ 20100</span>
            </div>
            <div className="FS-summary-green-bar">Summary</div>
            <div className="FS-final-footer-box">
              <span>Annual Total Amount($)</span>
              <span className="FS-bold-amount-value">$ 20100</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FeeStructure;